module.exports = __webpack_public_path__ + "img/40_00_078_225.8f523bfa.jpg";